import {
  Button as MantineButton
} from "@mantine/core";
import { forwardRef } from "react";
import type {
  ButtonProps as MantineButtonProps} from "@mantine/core";
import type { ComponentPropsWithoutRef} from "react";

export interface ButtonProps
  extends MantineButtonProps,
    Omit<ComponentPropsWithoutRef<"button">, keyof MantineButtonProps> {}

export const Button = forwardRef<
  HTMLButtonElement,
  ButtonProps & { appVariant?: "primary" | "secondary" | "ghost" | "glowing" }
>(({ appVariant = "primary", radius = "xl", size = "md", ...props }, ref) => {
  let computedProps: MantineButtonProps = {};
  if (appVariant === "secondary") {
    computedProps = { variant: "filled", color: "gray", ...computedProps };
  } else if (appVariant === "ghost") {
    computedProps = { variant: "subtle", ...computedProps };
  } else if (appVariant === "glowing") {
    computedProps = {
      variant: "filled",
      style: {
        boxShadow:
          "0 0 10px color-mix(in srgb, var(--mantine-color-primary-6) 50%, transparent), 0 0 15px color-mix(in srgb, var(--mantine-color-cyan-5) 70%, transparent)",
        ...(props.style as React.CSSProperties),
      },
      ...computedProps,
    };
  }
  return (
    <MantineButton
      ref={ref}
      radius={radius}
      size={size}
      {...computedProps}
      {...props}
    />
  );
});

Button.displayName = "Button";
